import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { PiHandsClappingDuotone } from "react-icons/pi";
import { IoIosShareAlt } from "react-icons/io";
import useBlogsData from '../hooks/useBlogsData';
import Views from '../components/Views';
import Markdown from '../components/Markdown';
import LoadingSpinner from '../components/Spinner';

const PageContainer = styled.div`
  padding: 20px;
  background-color: #eee;
  margin-top: 6rem;
  /* height: 100%; */
  min-height: 85vh;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
`;

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40vw, 1fr));
  gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 90vw;
  }
`;

const BlogItem = styled.div`
  position: relative;
  height: 300px;
  background-color: #f9f9f9;
  border-radius: 7px;
  padding: 10px 20px;
  transition: transform 0.3s ease;
  overflow: auto;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1),
              0 16px 32px rgba(0, 0, 0, 0.1);
  &:hover {
    transform: translateY(-5px);
  }
`;

const BlogTitle = styled.h2`
  font-size: 20px;
  color: #555;
  margin-bottom: 10px;
`;

const BlogCard = styled.div`
  /* border: 1px solid #ccc; */
  /* border-radius: 8px; */
  padding: 0 10px;
  margin-bottom: 20px;
  overflow: hidden;
  overflow-block: hidden;
  text-overflow: ellipsis;
  max-height: 80%;
  h1{
    color: #556;
  }
  h2, code{
    display: none;
  }
`;

const BlogContent = styled.div`
  font-size: 14px;
  color: #666;
`;

const BlogImage = styled.img`
  max-height: 125px;
  width: 100%;
  object-fit: cover;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  max-width: 600px;
  padding: 0 20px;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const ShareButton = styled.button`
  background-color: transparent;
  color: #007bff;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:focus {
    outline: none;
  }

  &:hover {
    color: #0056b3;
  }
`;

const Loading = styled.div`
  display: flex;
  height: 50%;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 15%;
`

const Note = styled.p`
  /* color: #FFA500; */
  color: var(--color-brand-900);
  text-align: left;
  padding: 5px 0;
  margin-top: auto;
`;

const ErrorContainer = styled.code`
  color: #e66;
`;

const BlogsPage = () => {
  const { loading, error, blogs } = useBlogsData();

  const handleShare = (blogId) => {
    const blogUrl = `${window.location.origin}/blog/${blogId}`;

    if (navigator.share) {
      navigator.share({
        title: 'Check out this blog post!',
        text: 'Read this interesting blog post',
        url: blogUrl,
      })
        .then(() => console.log('Blog shared successfully'))
        .catch((error) => console.error('Share failed:', error));
    } else {
      alert(`Share blog ${blogId} at: ${blogUrl}`);
    }
  };

  return (
    <PageContainer>
      <Title>Latest Blogs</Title>
      {loading && (
        <>
          <Note><b>Note: </b><span>loading from a slow server</span> (max: 60sec) please wait...</Note>
          <ErrorContainer>Server's subscription has been expired!</ErrorContainer>
          <Loading><LoadingSpinner size={65} /></Loading>
        </>
      )}
      {error && (
        <ErrorContainer>
          <b>Error:</b> Failed to load data from server!<br></br>{error}
        </ErrorContainer>
      )}
      <BlogGrid>
        {blogs.map(blog => (
          <Link
            to={{ pathname: `/blog/${blog.id}` }}
            key={blog.id}
            style={{ textDecoration: 'none' }}
          >
            <BlogItem>
              {/* <BlogTitle>{blog.title}</BlogTitle> */}
              {/* {blog.image && <BlogImage src={blog.image} alt={blog.title} />} */}
              {/* <div >{blog.content}</div> */}

              <BlogCard>
                <BlogContent>
                  <Markdown style={{ fontSize: '14px' }} content={blog.content} />
                </BlogContent>
              </BlogCard>
              <ButtonContainer>
                {/* <ClapButton onClick={() => handleClap(blog)} clapped={''}>
                <PiHandsClappingDuotone size={24} /> {blog.claps || 0}
              </ClapButton> */}
                <Views>{blog.views}</Views>
                <ShareButton onClick={() => handleShare(blog.id)}>
                  <IoIosShareAlt size={24} />
                </ShareButton>
              </ButtonContainer>
            </BlogItem>
          </Link>
        ))}
      </BlogGrid>
    </PageContainer>
  )
};

export default BlogsPage;
